<template>
 	<base-modal
 		class="confirm-policy-modal"
		:closeable="false"
		:open="isOpenPolicyModal"
		:unmountAfterMs="unmountAfterMs"
		:controlled="true"
	>
		<div class="policy-modal" id="policy_modal">
			<div class="policy-modal__header">
				{{$t('components.policyModal.header')}}
			</div>
			<div class="policy-modal__body">
				<div class="policy-modal__content mb-8">
					<div v-html="$t('components.policyModal.body')"></div>
					<vs-checkbox v-model="acceptPolicy"
								 vs-value="save"
								 class="mt-3" >
						{{$t('components.policyModal.save')}}
					
					</vs-checkbox>
					<vs-checkbox v-model="acceptPolicy"
								 vs-value="purpose"
								 class="mt-3" >
						{{$t('components.policyModal.purpose')}}
					</vs-checkbox>
					<vs-checkbox v-model="acceptPolicy"
								 vs-value="permission"
								 class="mt-3" >
						{{$t('components.policyModal.permission')}}
					</vs-checkbox>
				</div>
				<divider class="mt-3" color="dark" />
				<div class="mt-3 text-center">
					<Button  class="ml-auto w-auto" color="primary" @click="updateUserPolicy" :disabled="acceptPolicy.length < 3">{{$t('components.policyModal.submit')}}</Button>
				</div>
			</div>
		</div>
 	</base-modal>
</template>

<script>

import BaseModal from "../Modal/BaseModal.vue";
import Button from "../Button/Button.vue";
import Divider from "../Divider/Divider.vue";
import userPolicyService from "../../core/services/userPolicyService";
import {OPEN_POLICY} from "../../store/modules/policyModule";
import store from "../../store/store";
export default {
	components: {
		Divider,
		Button,
		BaseModal
	},
	computed: {
		isOpenPolicyModal() {
			return this.$store.state.policy.isOpenPolicy;
		}
	},
	data() {
		return {
			acceptPolicy: [],
			unmountAfterMs: 500,
			isError: false,
		}
	},
	methods: {
		updateUserPolicy() {
			this.$site.loading.open("#policy_modal");
			this.isError = this.acceptPolicy.length < 3;
			if (this.isError) return;
			userPolicyService.updateUserPolicy({'policy' : true}).then((response) => {
				if (response.data.data.isAcceptedPolicy === true) {
					store.dispatch(OPEN_POLICY, false);
				}
			}) .catch((error) => {
				this.$vs.notify({
                    title: 'Có lỗi xảy ra',
                    color: 'danger',
                    position: 'top-right',
                });
                return null;
           
        })
        .finally(() => {
            this.acceptPolicy = [];
            this.$site.loading.close("#policy_modal");
        });
		},
		// sse
		sseNotifications(publisherId) {
			const sseClient = this.$sse.create({
				url: `${process.env.APP_URL_SOCKET_NOTIFICATIONS}/socket/${publisherId}`,
				format: 'json',
			});
			sseClient.connect()
				.then(sse => {
					sse.on('message', (data,lastEventId ) => {
						this.handlePolicyModal(data.isAcceptedPolicy)
					});
				})
				.catch((err) => {
					console.error('Failed to connect to server', err);
				});
		},

		handlePolicyModal(isAcceptedPolicy = true) {
			if (isAcceptedPolicy) {
                this.$store.dispatch(OPEN_POLICY, false);
				this.unmountAfterMs = 200;
			} else {
                this.$store.dispatch(OPEN_POLICY, true);
			}
		},
	},
	mounted() {
	
	}
}
</script>
<style lang="scss">
.confirm-policy-modal {
	.base-modal__main {
		width: 100%;
		max-width: 688px;
		min-height: 280px;
		border-radius: 6px;
		background-color: var(--vs-hex-white);
		padding: 0;
	}
	.policy-modal {
		&__header {
			font-size: 18px;
			@media only screen and (max-width: 768px) {
				font-size: 16px;
			}
			padding: 12px 26px;
			gap: 8px;
			background-color: #F8F8F8;
			border-radius: 6px;
			font-weight: 500;
		}
		&__body {
			color: #6E6B7B;
			padding: 20px 25px;
			text-align: justify;
			.policy-modal__content {
				font-weight: 400;
			}
		}
		&__link {
			color: #6E6B7B;
			text-decoration: underline;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Policy/PolicyModal.vue